import { initializeApp } from "firebase/app";
import { initializeFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { getMessaging, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

const app = initializeApp(firebaseConfig);

// App Check（スクリプトからの直接アクセス・多重アカウント作成の抑止）。
// REACT_APP_APPCHECK_SITE_KEY（reCAPTCHA Enterprise のサイトキー）がある時だけ有効化する。
// 手順: Firebase コンソール > App Check > Web アプリに reCAPTCHA Enterprise を登録 → キーを .env に →
//       しばらく「監視」で運用し、拒否が無いことを確認してから Firestore / Functions で「強制」にする。
// ローカル開発では REACT_APP_APPCHECK_DEBUG=true でデバッグトークンを使う。
// appCheckReady: App Check の初期化が終わった印。App Check を強制している callable（openTochi）は、
// これを待ってから呼ぶ（ページを開いた直後に呼ぶと、証明が付かずに弾かれるため）。
export const appCheckReady = process.env.REACT_APP_APPCHECK_SITE_KEY
  ? import("firebase/app-check")
      .then(({ initializeAppCheck, ReCaptchaEnterpriseProvider }) => {
        if (process.env.REACT_APP_APPCHECK_DEBUG === "true") {
          // eslint-disable-next-line no-restricted-globals
          self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
        }
        initializeAppCheck(app, {
          provider: new ReCaptchaEnterpriseProvider(process.env.REACT_APP_APPCHECK_SITE_KEY),
          isTokenAutoRefreshEnabled: true,
        });
      })
      .catch(() => {})
  : Promise.resolve();

// WebChannel トランスポートが StrictMode の listener churn 等で
// "INTERNAL ASSERTION FAILED (ID: ca9 / b815)" を踏むのを回避するため、
// long-polling を自動検出させる
export const db = initializeFirestore(app, {
  experimentalAutoDetectLongPolling: true,
});
export const auth = getAuth(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, "asia-northeast1");

// FCM は HTTPS かつ対応ブラウザのみ初期化
export const messagingPromise = isSupported().then((ok) =>
  ok ? getMessaging(app) : null
);